// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__lvdcY","title":"Login_title__j2Na4","createQuiz":"Login_createQuiz__66IKr"};